'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('housing_production', {
      url: '/account/housing/housing_production?jurisdiction&sta_recid&policyName',
      template: '<housing-production></housing-production>',
      authenticate: true,
      params: {
        jurisdiction: null,  // Default value if not provided
        sta_recid: null,     // Default value if not provided
        policyName: null     // Default value if not provided
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/housing/housing_production/housing_production.routes.js